// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_registro-acoes_registro-acoes_module_ts":"264ee538eb533130","node_modules_angular_fire_node_modules_firebase_compat_messaging_dist_esm_index_esm_js":"5aa7a3bd52466327"}[chunkId] + ".js";
};